import React, { ReactNode } from 'react'
import { View, TouchableOpacity } from 'react-native'
import Icon from 'react-native-vector-icons/Feather'
import tw from 'tailwind-rn'

import styles from './styles'
import HGIcon from '../HGIcon'
import HGText from './HGText'

export type ListItemCategory = 'link' | 'download' | 'custom'

export type ListItemType = {
  type: ListItemCategory | (() => ListItemCategory)
  title?: string
  description?: string
  disabled: boolean
  content?: ReactNode
  onPress: () => void
}

export type Props = {
  item: ListItemType
}

const HGListItem = ({ item }: Props) => {
  const { title, description, onPress, disabled, type = 'link', content } = item

  // const _handlePress = () => {}

  if (type === 'custom') {
    return typeof content === 'function' ? content() : content
  }

  return (
    <View style={tw('mb-3')}>
      <TouchableOpacity
        onPress={() => onPress(item)}
        style={[styles.listItemInner, disabled && styles.listItemDisabled]}
        disabled={disabled}
      >
        <View style={styles.listItemTextContainer}>
          <HGText style={styles.listItemTitle}>{title}</HGText>
          {description && description.length && (
            <HGText style={styles.listItemDescription}>{description}</HGText>
          )}
        </View>

        {type === 'link' && (
          <View style={styles.listItemIconContainer}>
            <Icon name="chevron-right" size={40} style={styles.listItemIcon} />
          </View>
        )}

        {type === 'download' && (
          <View style={styles.listItemIconContainer}>
            <HGIcon
              name="download"
              size={25}
              style={[styles.listItemIcon, styles.listItemIconCustom]}
            />
          </View>
        )}
      </TouchableOpacity>
    </View>
  )
}

export default HGListItem
